/**
 * 定时任务管理 API
 * 
 * 提供定时任务状态查询和手动触发功能
 * 
 * @author AI Assistant
 * @created 2025-11-15
 */

import httpRequest from '@/utils/api'
import type {
  TaskStatusListResponseData,
  TaskExecutionResponse,
} from '@/types/admin/tasks'

enum API {
  tasksStatus = '/admin/tasks/status',
  resetQuotas = '/admin/tasks/reset-quotas',
  checkExpiredSubscriptions = '/admin/tasks/check-expired-subscriptions',
  syncRedisToDb = '/admin/tasks/sync-redis-to-db',
  unlockCommissions = '/admin/tasks/unlock-commissions',
}

/**
 * 获取所有定时任务状态
 * 
 * @returns 任务状态列表响应
 */
export const getTasksStatusAPI = () => {
  return httpRequest.get<TaskStatusListResponseData>({
    url: API.tasksStatus,
  })
}

/**
 * 手动触发重置配额任务
 * 
 * @returns 任务执行响应
 */
export const triggerResetQuotasAPI = () => {
  return httpRequest.post<TaskExecutionResponse>({
    url: API.resetQuotas,
  })
}

/**
 * 手动触发检查过期订阅任务
 * 
 * @returns 任务执行响应
 */
export const triggerCheckExpiredSubscriptionsAPI = () => {
  return httpRequest.post<TaskExecutionResponse>({
    url: API.checkExpiredSubscriptions,
  })
}

/**
 * 手动触发同步 Redis 到数据库任务
 * 
 * @returns 任务执行响应
 */
export const triggerSyncRedisToDbAPI = () => {
  return httpRequest.post<TaskExecutionResponse>({
    url: API.syncRedisToDb,
  })
}

/**
 * 手动触发解锁到期佣金任务
 * 
 * @returns 任务执行响应
 */
export const triggerUnlockCommissionsAPI = () => {
  return httpRequest.post<TaskExecutionResponse>({
    url: API.unlockCommissions,
  })
}

